export default "PRODUCT_RESULT_MODULE";
